import { GoogleAuthProvider, I18nProvider, QueryProvider, ThemeProvider } from './providers';
import { Router } from './Router';

export function App() {
  return (
    <I18nProvider>
      <ThemeProvider>
        <QueryProvider>
          <GoogleAuthProvider>
            <Router />
          </GoogleAuthProvider>
        </QueryProvider>
      </ThemeProvider>
    </I18nProvider>
  );
}
